// @ts-check
import { Trans } from '@lingui/macro';
import { View } from '@react-pdf/renderer';
import React from 'react';
import Page from '../../components/Page';
import type { Collection, MyListPageItem } from './MyList';
import Footer from './MyList.Footer';
import { Text } from './Text';

export default function TastingBookletIndexPage({
  items,
  collection,
  style,
  bleed = 0,
  ...rest
}: {
  items: MyListPageItem[];
  collection: Collection;
  style?: any;
  bleed?: number;
}) {
  const sortedAlpha = items.sort((a, b) => a.name.localeCompare(b.name));
  const pagedIndex = Array.from(Array(Math.ceil(sortedAlpha.length / 30))).map(
    (_, index) => {
      return sortedAlpha.slice(index * 30, index * 30 + 30);
    }
  );
  return (
    <React.Fragment>
      {pagedIndex.map((page, index) => (
        <Page
          key={`page-${index}`}
          size="A4"
          style={[
            { paddingVertical: `${bleed}mm`, paddingHorizontal: `${bleed}mm` },
            style,
          ]}
          {...rest}
        >
          <View style={{ alignItems: 'center', paddingTop: 30 }}>
            <View style={{ width: 300 }}>
              <View
                style={{
                  flexDirection: 'row',
                  borderBottom: 1,
                  borderBottomColor: '#CCC',
                  paddingVertical: 10,
                  marginVertical: 10,
                }}
              >
                <Text style={{ width: 75, flexGrow: 0, flexShrink: 0 }}> </Text>
                <Text variant="bold" style={{ fontSize: 18 }}>
                  <Trans>Exhibitors</Trans>
                </Text>
              </View>
              {page.map((item, index) => (
                <View
                  key={item.exhibitorId}
                  style={{ flexDirection: 'row', paddingVertical: 3 }}
                >
                  <Text style={{ width: 75, flexGrow: 0, flexShrink: 0 }}>
                    {item.stand?.name}
                  </Text>
                  <Text variant="bold">{item.name}</Text>
                </View>
              ))}
            </View>
          </View>
          <Footer collection={collection} />
        </Page>
      ))}
    </React.Fragment>
  );
}
